var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('BaseContent',{attrs:{"title":"Your Mixes"}},[_c('BaseSection',{attrs:{"padded":""}},[(_vm.mixesList.length)?_c('MixTableBlock',{attrs:{"mixes":_vm.mixesList,"should-transition":_vm.shouldTransition,"genres":"","is-indexed-list":""}}):_c('BaseEmptyList',{attrs:{"error":{
                    title: `No mixes yet!`,
                    paragraph: `Like a mix? Tap the ♡ button to add it to this list.`,
                }}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }